import { Component, OnInit } from '@angular/core';
import { FormStatus } from 'app/components/form-status/form-status.constants';
import { ConsultService } from 'app/services/consult/consult.service';
import { ConsultListModel } from 'app/model/consult.list.model';
import { MasterService } from 'app/services/master/master.service';
import { AccountModel } from 'app/model/auth.account.model';
import { AuthService } from 'app/services/auth/auth.service';


@Component({
    selector: 'app-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss']
})
export class ListView implements OnInit {

    itemsPerPage: number = 10;

    accountInfo: AccountModel;

    /** ステータス情報 */
    status: Array<{id:string; name:string, color?: string}>;
    
    currentStatus: string;

    /** 相談情報一覧 */
    allConsults: Array<ConsultListModel & {harassmentTypeName?: string; consultantName?: string}>;

    tabConsults: Array<ConsultListModel & {harassmentTypeName?: string; consultantName?: string}>;

    pageConsults: Array<ConsultListModel & {harassmentTypeName?: string; consultantName?: string}>;

    paging: {
        totalItems: number;
        currentPage: number;
    }

    loading = false;

    constructor(private consultService: ConsultService, private masterService: MasterService, private authService: AuthService) {
        this.initStatus();
        this.paging = {
            totalItems: 0,
            currentPage: 1
        }
    }

    async ngOnInit() {
        try {
            this.loading = true;

            this.accountInfo = await this.authService.getAccount();

            this.allConsults = await this.consultService.getConsults();

            for (let item of this.allConsults) {
                item.harassmentTypeName = await this.masterService.getHarassmentTypeName(item.harassmentType);
                item.consultantName = await this.masterService.getConsultantName(item.consultantMail);
            }
            this.changeTab(FormStatus.ConfirmingFact);

        } finally {
            this.loading = false;
        }
       
    }

    changeTab(tabId: string) {

        this.currentStatus = tabId;
        this.tabConsults = this.allConsults.filter(
            item => (
                tabId == item.status || 
                tabId == 'all'
            )
        );

        this.paging.totalItems = this.tabConsults.length;
        this.paging.currentPage = 1;
        this.pageChanged({page: 1});
    }

    pageChanged(event: any) {
        let beginIndex = (event.page - 1) * this.itemsPerPage;
        this.pageConsults = this.tabConsults.filter( (item, index) => (index >= beginIndex && index < beginIndex + this.itemsPerPage ) )
    }

    getStatus(statusId: string): {id:string; name:string} {
        for (let item of this.status) {
            if (item.id === statusId) {
                return item;
            }
        }
    }

    private initStatus() {

        this.status = [
            // {
            //     id: FormStatus.Remanded,
            //     name: '作成',
            //     color: 'badge-faded'
            // },
            // {
            //     id: FormStatus.Registered,
            //     name: '相談登録済',
            //     color: 'badge-secondary'
            // },
            // {
            //     id: FormStatus.ConsultantChecking,
            //     name: '相談窓口確認中',
            //     color: 'badge-info'
            // },
            {
                id: FormStatus.ConfirmingFact,
                name: '事実確認中',
                color: 'badge-primary'
            },
            // {
            //     id: FormStatus.DMChecking,
            //     name: '処遇決定者確認中',
            //     color: 'badge-warning'
            // },
            // {
            //     id: FormStatus.ConsulterEndorsing,
            //     name: '相談者承認中',
            //     color: 'badge-dark'
            // },
            {
                id: FormStatus.AllDone,
                name: '完了',
                color: 'badge-success'
            },
            {
                id: 'all',
                name: 'すべて'
            },
        ]
    }
}



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/views/list/list.component.ts